import { render } from "./report-overview-table.vue?vue&type=template&id=47f40c36&scoped=true"
import script from "./report-overview-table.vue?vue&type=script&lang=js"
export * from "./report-overview-table.vue?vue&type=script&lang=js"

import "./report-overview-table.vue?vue&type=style&index=0&id=47f40c36&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f40c36"]])

export default __exports__